import ActionTypes from '../../constants/ActionTypes';
import common from '../_common/actions';
import Select from '../Select'; // ============ creators ===========

var add = common.add(ActionTypes.CASES);
var create = common.create(Select.cases.getSubstate, 'cases', ActionTypes.CASES);
var deleteItem = common["delete"](Select.cases.getSubstate, 'cases', ActionTypes.CASES);
var saveEdited = common.saveEdited(Select.cases.getSubstate, 'cases', ActionTypes.CASES);
var setActiveKey = common.setActiveKey(ActionTypes.CASES);
var setActiveKeys = common.setActiveKeys(ActionTypes.CASES);
var updateEdited = common.updateEdited(Select.cases.getSubstate, ActionTypes.CASES);
var updateStateFromView = common.updateSubstateFromView(ActionTypes.CASES);
var useKeys = common.useKeys(Select.cases.getSubstate, 'cases', ActionTypes.CASES);
var useKeysClear = common.useKeysClear(ActionTypes.CASES);
var useIndexed = common.useIndexed(Select.cases.getSubstate, 'cases', ActionTypes.CASES);
var useIndexedClear = common.useIndexedClear(ActionTypes.CASES);
var clearIndex = common.clearIndex(ActionTypes.CASES);
var refreshUses = common.refreshUses(Select.cases.getSubstate, "cases", ActionTypes.CASES);

var setActiveKeyAndEnsureDependencies = function setActiveKeyAndEnsureDependencies(key) {
  return function (dispatch, getState, options) {
    dispatch(setActiveKey(key));

    if (options) {
      dispatch(options.ensureDependenciesOfActiveMetadataType('case'));
    }
  };
};

var setActiveKeysAndEnsureDependencies = function setActiveKeysAndEnsureDependencies(keys) {
  return function (dispatch, getState, options) {
    dispatch(setActiveKeys(keys));

    if (options) {
      dispatch(options.ensureDependenciesOfActiveMetadataType('case'));
    }
  };
}; // ============ actions ===========
// ============ export ===========


export default {
  add: add,
  create: create,
  "delete": deleteItem,
  refreshUses: refreshUses,
  saveEdited: saveEdited,
  setActiveKey: setActiveKeyAndEnsureDependencies,
  setActiveKeys: setActiveKeysAndEnsureDependencies,
  updateEdited: updateEdited,
  updateStateFromView: updateStateFromView,
  useIndexed: useIndexed,
  useIndexedClear: useIndexedClear,
  clearIndex: clearIndex,
  useKeys: useKeys,
  useKeysClear: useKeysClear
};